import store from '@/store'

export default {
  inserted: function(el, { value: { id, setActive } }) {
    el.addEventListener('click', event => {
      const classes = ['panel', 'section', 'tabs', 'herospark-banner'],
        target = classes.map(cl => `[class^="${cl}"]`).join(',')

      const closest = event.target.closest(target)
      const [, closestId] = closest.classList[0].split('_')

      if (closestId === id) {
        setActive(id)
      }
      store.dispatch('landing/setCurrentNavBar', 'Landing')
    })
  },
}
